export default __webpack_public_path__ + "locales/ja-JP/ChangePhoneDialog.json?hash=24f0f16f76523417ab6bb20f033c4976";